import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

export default function SignatureSection(props) {
  const { ctx, res, profile, classes, link } = props;
  const readOnly = !ctx.state.editForm;

  const blockAndAlert = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  const Shield = readOnly ? (
    <div
      style={{ position: 'absolute', inset: 0, zIndex: 2 }}
      tabIndex={-1}
      aria-hidden="true"
      onMouseDown={blockAndAlert}
    />
  ) : null;

  return (
    <div style={{ display: ctx.state.tabValue === 3 ? 'flex' : 'none', flexDirection: ctx.state.tabValue === 3 ? 'column' : '', marginTop: '1rem' }}>
      <h2 style={{ margin: '0' }}>{res.ASSINATURA}</h2>
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ position: 'relative', width: '50%', paddingRight: '1rem' }}>
            {Shield}
            <FormControl style={{ marginTop: '1rem', width: '100%' }}>
              <InputLabel>{res.RESPONSAVEL_TECNICO}</InputLabel>
              <Select
                id="executor"
                value={ctx.state.executor}
                onChange={ctx.handleTechnicianChange}
                inputProps={{ tabIndex: readOnly ? -1 : 0, 'aria-readonly': readOnly }}
                MenuProps={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  getContentAnchorEl: null,
                }}
              >
                {ctx.state.technicians.map((technician) => (
                  <MenuItem key={technician.id} value={technician.name}>
                    {technician.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <TextField
            id="creaExecutor"
            label={res.CFTA}
            style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
            value={ctx.state.executor_cfta_cpf}
            onChange={ctx.handleChange('executor_cfta_cpf')}
            InputProps={{ readOnly }}
            onMouseDown={readOnly ? blockAndAlert : undefined}
          />
          <TextField
            id="executorEmail"
            label={res.EMAIL}
            style={{ marginTop: '1rem', width: '50%' }}
            value={ctx.state.executorEmail ? ctx.state.executorEmail : ''}
            onChange={ctx.handleChange('executorEmail')}
            InputProps={{ readOnly }}
            onMouseDown={readOnly ? blockAndAlert : undefined}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ position: 'relative', width: '50%', paddingRight: '1rem' }}>
            {Shield}
            <FormControl style={{ marginTop: '1rem', width: '100%' }}>
              <InputLabel>{res.CLIENTE}</InputLabel>
              <Select
                id="client"
                value={ctx.state.client}
                onChange={ctx.handleClientChange}
                inputProps={{ tabIndex: readOnly ? -1 : 0, 'aria-readonly': readOnly }}
                MenuProps={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  getContentAnchorEl: null,
                }}
              >
                {ctx.state.clients.map((client) => (
                  <MenuItem key={client.id} value={client.name}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <TextField
            id="clientEmail"
            label={res.EMAIL}
            style={{ marginTop: '1rem', width: '50%' }}
            value={ctx.state.clientEmail ? ctx.state.clientEmail : ''}
            onChange={ctx.handleChange('clientEmail')}
            InputProps={{ readOnly }}
            onMouseDown={readOnly ? blockAndAlert : undefined}
          />
        </div>
      </div>
    </div>
  );
}